import React from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { Provider } from 'react-redux';

import { authProtectedRoutes, publicRoutes } from "./routes";

import AuthMiddleware from "./routes/route";

import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '../src/assets/styles/themes.scss';
import '../src/assets/styles/global.css';
import NotFound from "./pages/NotFound";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import { ToastContainer } from 'react-toastify';
import store from './store';

const AppRoutes = () => {
  const routes = [
    ...publicRoutes.map((route) => ({
      path: route.path,
      element: route.component,
    })),
    ...authProtectedRoutes.map((route) => ({
      path: route.path,
      element: (
        <AuthMiddleware>
          <Sidebar />
          <div className="wrapper d-flex flex-column min-vh-100">
            <Header />
            <div style={{ marginBottom: '80px',}} className="mx-5 body flex-grow-1 page-content">
              {route.component}
            </div>
            <Footer />
          </div>
        </AuthMiddleware>
      ),
    })),
    {
      path: "*",
      element: <NotFound />,
    },
  ];
  return useRoutes(routes);
};

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <ToastContainer />
        <AppRoutes />
      </Router>
    </Provider>
  );
};

export default App;